import React from 'react';
import FlipCard from './FlipCard';
import './WorkExperience.css';

const WorkExperience = () => {
  const workData = [
    {
      title: "Weis, DuBrock, Doody, & Maher",
      subtitle: "Legal Assistant",
      date: "February 2025 – Present",
      location: "Chicago, IL",
      front: "Currently serving as a Legal Assistant, focusing on property tax appeals and client communication to ensure optimal legal outcomes.",
      back: [
        "Maintain client communication and process documents, ensuring exceptional client satisfaction and streamlined case progressions.",
        "Draft and file legal briefs and appeals, successfully reducing property tax burdens for Illinois clients through persuasive legal argumentation.",
        "Conduct comprehensive legal research and evidence compilation, preparing robust documentation for submission to local and state administrative offices."
      ]
    },
    {
      title: "Legal Aid Society of Metropolitan Family Services",
      subtitle: "Outreach Paralegal",
      date: "August 2024 - February 2025",
      location: "Chicago, IL",
      front: "Served as an Outreach Paralegal, focusing on immigrant rights advocacy and community education while supporting attorneys with case preparation.",
      back: [
        "Drafted and processed critical legal documents, including retainers and case files, maintaining meticulous organizational systems to ensure efficient case management and client file accessibility.",
        "Helped plan and participated in community outreach events to teach immigrants about their rights and pathways to citizenship.",
        "Conducted client intakes and presented them to attorneys."
      ]
    }
  ];

  return (
    <section id="work" className="section work-experience">
      <h2 className="section-title">Work Experience</h2>
      <div className="cards-container">
        {workData.map((work, index) => (
          <FlipCard
            key={index}
            title={work.title}
            subtitle={work.subtitle}
            date={work.date}
            location={work.location}
            front={work.front}
            back={work.back}
            animationDelay={index * 200} // Staggered delay: 0ms, 200ms, 400ms, etc.
          />
        ))}
      </div>
    </section>
  );
};

export default WorkExperience;
